import { topRated } from "@/mocks/anime";
import SectionHeading from "./SectionHeading";

const medals = ['ri-medal-fill', 'ri-medal-fill', 'ri-medal-fill', 'ri-trophy-line', 'ri-trophy-line'];

export default function TopRated() {
  return (
    <section id="top" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="高分番榜"
          title="照这份高分榜补，几乎不踩雷"
          desc="综合多个平台评分与观众口碑选出的头部好番，榜单每月校准。想找一部稳赢的番，从这里开始准没错。"
        />

        <ol className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {topRated.map((item, i) => (
            <li key={item.id} className="relative">
              <article className="group h-full overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200">
                <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-100">
                  <img
                    src={item.image}
                    alt={`高分番第${i + 1}名：${item.title}`}
                    title={`${item.title} - 小虎看番高分榜第${i + 1}名`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span
                    className={`absolute left-3 top-3 inline-flex h-9 w-9 items-center justify-center rounded-full font-heading text-base ${
                      i < 3 ? 'bg-primary-500 text-background-50' : 'bg-foreground-950/70 text-background-50'
                    }`}
                  >
                    {i + 1}
                  </span>
                  <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-bold text-foreground-950">
                    <i className="ri-star-fill text-amber-500" />
                    {item.score.toFixed(1)}
                  </span>
                </div>
                <div className="p-3 md:p-4">
                  <h4 className="font-heading text-base text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h4>
                  <div className="mt-2 flex flex-wrap gap-1.5">
                    {item.tags.slice(0, 3).map((tag) => (
                      <span key={tag} className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <p className="mt-3 line-clamp-3 text-xs leading-5 text-foreground-600">{item.synopsis}</p>
                  <div className="mt-3 flex items-center gap-1 text-xs text-primary-600">
                    <i className={medals[i]} />
                    <span className="font-medium">{i + 1} 名 · {item.year}</span>
                  </div>
                </div>
              </article>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}